/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';

const baseUrl = localStorage.getItem('REACT_APP_API_URL') || 'https://api.edge.partiu.com.br/api';

export function isAuthenticated() {
  return (
    axiosInstanceV2.defaults.headers.common['Authorization'] && axiosInstance.defaults.headers.common['Authorization']
  );
}
function validateStatus(status: number): boolean {
  if (status === 401) {
    setAccessToken(null);
    localStorage.removeItem('token');
    window.location.reload();
  }
  return status < 400;
}

export function setAccessToken(token: string | null, tokenExpirationDate?: string | null) {
  if (token === null || (tokenExpirationDate && new Date(tokenExpirationDate) < new Date())) {
    axiosInstance.defaults.headers.common['Authorization'] = null;
    axiosInstanceV2.defaults.headers.common['Authorization'] = null;
    axiosInstanceV3.defaults.headers.common['Authorization'] = null;
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpirationDate');
    return;
  }
  axiosInstance.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
  axiosInstanceV2.defaults.headers.common['Authorization'] = `TOKEN ${token}`;
  axiosInstanceV3.defaults.headers.common['Authorization'] = `TOKEN ${token}`;

  localStorage.setItem('token', token);

  if (tokenExpirationDate) localStorage.setItem('tokenExpirationDate', tokenExpirationDate);
}

export const axiosInstance = axios.create({
  baseURL: baseUrl + '/v1',
  validateStatus,
});

export const axiosInstanceV2 = axios.create({
  baseURL: baseUrl + '/v2',
  validateStatus,
});

export const axiosInstanceV3 = axios.create({
  baseURL: baseUrl + '/v3',
  validateStatus,
});

const configToken = (config: any) => {
  const agreementId = localStorage.getItem('agreementId');
  if (agreementId) config.headers['X-Agreement-Id'] = agreementId;
  else config.headers['X-Agreement-Id'] = JSON.parse(localStorage.getItem('theme') || 'null')?.id;
  return config;
};

axiosInstance.interceptors.request.use(configToken, (error) => Promise.reject(error));
axiosInstanceV2.interceptors.request.use(configToken, (error) => Promise.reject(error));
axiosInstanceV3.interceptors.request.use(configToken, (error) => Promise.reject(error));

function getInitialAuth() {
  try {
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    if (tokenFromUrl) {
      return { token: tokenFromUrl, expirationDate: params.get('tokenExpirationDate') };
    }
  } catch {}
  return {
    token: localStorage.getItem('token'),
    expirationDate: localStorage.getItem('tokenExpirationDate'),
  };
}

const { token: initialToken, expirationDate: initialExpirationDate } = getInitialAuth();
if (initialToken) setAccessToken(initialToken, initialExpirationDate);
